import Stats from '../helpers/Stats';
import { getHeaderSectionHeight } from '../helpers/HeaderSection';
import { initCollectionHeaderFilters } from './CollectionHeaderFilters';
import { isConstructorCollectionActive } from './external-systems/constructor.io/widgets/collection/mode';

let controller;
let fetch_active = false;

const textToCamelCase = (str) => {
  return str
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase()) // Usuwanie niealfanumerycznych znaków i zmiana kolejnej litery na dużą
    .replace(/^[a-z]/, (chr) => chr.toUpperCase()); // Zmiana pierwszej litery na wielką
};

const filterIDCollab = 'filter.p.m.GLDProductsDetails.collab';
const FACET_FILTER_SUBMIT_DELAY = 500;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.controller = new AbortController();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.limit = document.querySelector(
      '[data-collection-products]'
    ).dataset.limit;
    this.submitTimeout = null;

    this.onFormInput = this.onFormInput.bind(this);
    this.onFormKeyDown = this.onFormKeyDown.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.onFormInput);
    facetForm.addEventListener('keydown', this.onFormKeyDown);
    facetForm.addEventListener('submit', this.onFormSubmit);

    // FacetFiltersForm.setCollabs();
    // if (facetForm)
    // facetForm.addEventListener('onChange', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initFixedHeaderFilters();
  }

  isPriceRangeInput(element) {
    return element?.closest?.('price-range');
  }

  clearPendingSubmit() {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
      this.submitTimeout = null;
    }
  }

  scheduleSubmit(event, delay = FACET_FILTER_SUBMIT_DELAY) {
    this.clearPendingSubmit();
    this.submitTimeout = setTimeout(() => {
      this.submitTimeout = null;
      if (controller) {
        controller.abort();
      }
      this.onSubmitHandler(event);
    }, delay);
  }

  onFormInput(event) {
    if (this.isPriceRangeInput(event.target)) {
      this.clearPendingSubmit();
      return;
    }

    this.scheduleSubmit(event);
  }

  onFormKeyDown(event) {
    if (event.key !== 'Enter' || !this.isPriceRangeInput(event.target)) {
      return;
    }

    event.preventDefault();
    if (event.target.form?.requestSubmit) {
      event.target.form.requestSubmit();
      return;
    }

    this.onSubmitHandler(event);
  }

  onFormSubmit(event) {
    this.clearPendingSubmit();
    if (controller) {
      controller.abort();
    }
    this.onSubmitHandler(event);
  }

  initFixedHeaderFilters() {
    this.collectionHeaderFilters = initCollectionHeaderFilters(document);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      if (
        isConstructorCollectionActive() ||
        event.state?.constructorCollection
      ) {
        return;
      }

      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('[data-filter-remove]').forEach((element) => {
      element.toggleAttribute('data-filter-disabled', disable);
      element.setAttribute('aria-disabled', disable ? 'true' : 'false');
    });
  }

  static setURL(searchParams, event = null) {
    const wrapper = event?.target
      ? event.target.closest('[data-collection-section]')
      : document.querySelector('[data-collection-section]');
    if (wrapper?.dataset?.sectionId) {
      searchParams += `${searchParams != '' ? '&' : ''}section_id=${
        wrapper.dataset.sectionId
      }`;
    }
    return `${window.location.pathname}?${searchParams}`;
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    if (isConstructorCollectionActive()) {
      return false;
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    document
      .querySelector('[data-filter-content]')
      .setAttribute('data-filter-loading', '');
    const url = FacetFiltersForm.setURL(searchParams, event);
    const filterDataUrl = (element) => element.url === url;

    let rendered = false;
    try {
      rendered = FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : await FacetFiltersForm.renderSectionFromFetch(url, event);
    } catch (err) {
      console.error(`Render filters error: ${err.message}`);
    }

    if (!rendered) {
      document
        .querySelector('[data-filter-content]')
        ?.removeAttribute('data-filter-loading');
      FacetFiltersForm.toggleActiveFacets(false);
      return;
    }
    // });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (event?.target) {
      const type =
        event.target.name ||
        event.target?.dataset?.name ||
        event.target?.parentNode?.dataset?.name;
      const value =
        event.target?.value ||
        event.target.dataset?.value ||
        event.target?.parentNode?.dataset?.value;
      const inputType =
        event.target.type ||
        event.target?.dataset?.type ||
        event.target?.parentNode?.dataset?.type;
      const filterLabel = event.target?.dataset?.filterLabel;
      const isChecked = event.target.checked;

      const event_category = 'filters--new';

      if (type && value) {
        if (Stats?.sendEventDataLayerViaShopify) {
          const eventFilterName = filterLabel || type;
          const eventValue = textToCamelCase(value);

          if (type == 'filter.v.m.GLDProductsDetails.color') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${eventValue}`,
            });
          } else if (type == 'filter.v.availability') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_boolean_${isChecked}`,
            });
          } else if (inputType == 'checkbox') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${inputType}_${isChecked}_${eventValue}`,
            });
          } else {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${inputType}_${eventValue}`,
            });
          }
        }

        if (window.gld_dy && window.gld_dy.enabled) {
          window.gld_dy.event({
            name: 'Filter Items',
            properties: {
              dyType: 'filter-items-v1',
              filterType: type,
              filterStringValue: value,
            },
          });
        }
      }
    }

    window.callbacks_filters_after_render_products =
      window.callbacks_filters_after_render_products || [];
    if (window?.callbacks_filters_after_render_products.length) {
      window.callbacks_filters_after_render_products.forEach((callback) =>
        callback()
      );
    }
  }

  static abortController = new AbortController();
  static fetchActive = false;

  static async renderSectionFromFetch(url, event) {
    try {
      controller = new AbortController();
      const signal = controller.signal;
      //         FacetFiltersForm.fetchActive = true;
      // fetch_active = true;
      const query = await fetch(url, { signal });
      // fetch_active = false

      const response = await query.text();
      const parsedHTML = new DOMParser().parseFromString(response, 'text/html');
      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        { html: response, url },
      ];
      FacetFiltersForm.renderFilters(parsedHTML, event);
      FacetFiltersForm.runBeforeRenderProductsCallbacks();
      FacetFiltersForm.renderProductCount(parsedHTML);
      FacetFiltersForm.renderProductCountFilters(parsedHTML);
      FacetFiltersForm.renderProductSortbyNavFilter(parsedHTML);
      FacetFiltersForm.renderProductGridContainer(parsedHTML);
      return true;
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error(`Get filters error: ${err.message}`);
      }
      fetch_active = false;
      return false;
    }
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cachedSection = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cachedSection) {
      console.warn('Filters cache miss: section could not be rendered.');
      return false;
    }

    const html = cachedSection.html;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    FacetFiltersForm.renderFilters(parsedHTML, event);
    FacetFiltersForm.runBeforeRenderProductsCallbacks();
    FacetFiltersForm.renderProductCount(parsedHTML);
    FacetFiltersForm.renderProductCountFilters(parsedHTML);
    FacetFiltersForm.renderProductSortbyNavFilter(parsedHTML);
    FacetFiltersForm.renderProductGridContainer(parsedHTML);
    return true;
    // window.callbacks_filters_after_render_products = window.callbacks_filters_after_render_products || []
    // if (window?.callbacks_filters_after_render_products.length) {
    //     window.callbacks_filters_after_render_products.forEach(callback => callback())
    // }
  }

  static runBeforeRenderProductsCallbacks() {
    window.callbacks_filters_before_render_products =
      window.callbacks_filters_before_render_products || [];
    if (window?.callbacks_filters_before_render_products.length) {
      window.callbacks_filters_before_render_products.forEach((callback) =>
        callback()
      );
    }
  }

  static renderProductGridContainer(parsedHTML) {
    const products = parsedHTML.querySelector('[data-collection-products]');
    const filters = parsedHTML.querySelector('[data-filter-drawer]');
    const filtersBestSelector =
      '[data-collection-top-filters][data-filter-type="best"] [data-collection-top-filter-list]';
    const filtersBest = parsedHTML.querySelector(filtersBestSelector);
    if (products) {
      products
        .querySelectorAll('[data-pagination-loading-overlay]')
        .forEach((overlay) => overlay.remove());
      const productNodes = document.createDocumentFragment();
      Array.from(products.childNodes).forEach((node) => {
        productNodes.appendChild(document.adoptNode(node));
      });
      document
        .querySelector('[data-collection-products]')
        .replaceChildren(productNodes);
    }
    if (filtersBest) {
      document.querySelector(filtersBestSelector).innerHTML =
        filtersBest.innerHTML;
    }
    if (filters) {
      document.querySelector('[data-filter-drawer]').innerHTML =
        filters.innerHTML;
    }
    if (window.LazyLoaderRun) {
      window.LazyLoaderRun();
    }
    if (window.dy_productCardPerformance) {
      window.dy_productCardPerformance();
    }
    FacetFiltersForm.srollToTopSection();
    document
      .querySelector('[data-filter-content]')
      .removeAttribute('data-filter-loading');
  }

  static renderProductCount(parsedHTML) {
    const productList = parsedHTML.querySelector(
      '[data-collection-products-list]'
    );
    const count = productList ? productList.dataset.productsCount : 0;
    const countCountainer = document.querySelector(
      '[data-collection-product-count]'
    );
    if (countCountainer) {
      countCountainer.innerHTML = `(${count})`;
    }
  }

  static renderProductSortbyNavFilter(parsedHTML) {
    const sortbyCheckedInput = parsedHTML.querySelector(
      'input[name="sort_by"][checked]'
    );
    const sortbyCheckedLabel = parsedHTML.querySelector(
      'input[name="sort_by"][checked] + label'
    );

    const customSelectSort = document.querySelector(
      '[data-gld-select="root"][data-gld-select-config="sort"]'
    );

    if (customSelectSort) {
      const customSelectSortValue = customSelectSort.querySelector(
        '[data-gld-select="value"]'
      );
      const customSelectSortOptions = customSelectSort.querySelectorAll(
        '[data-gld-select="option"]'
      );

      if (customSelectSortValue && customSelectSortOptions) {
        customSelectSortOptions.forEach(function (option) {
          if (option.dataset.gldState === 'selected') {
            option.removeAttribute('data-gld-state');
          }
        });

        customSelectSortValue.innerText = sortbyCheckedLabel
          ? sortbyCheckedLabel.innerText
          : customSelectSortValue.innerText;

        const newSelectedOption = document.querySelector(
          `[data-gld-select="option"][data-value="${sortbyCheckedInput.value}"]`
        );

        if (newSelectedOption) {
          newSelectedOption.setAttribute('data-gld-state', 'selected');
        }
      }
    }
  }

  static renderProductCountFilters(parsedHTML) {
    const counter_filters = parsedHTML.querySelector('[data-filter-counter]');
    const count = counter_filters ? counter_filters.innerText : 0;
    const countCountainer = document.querySelector('[data-filter-counter]');
    if (countCountainer) {
      countCountainer.innerText = count;
    }
  }

  static renderFilters(parsedHTML, event) {
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm [data-filter-group], #FacetFiltersFormMobile [data-filter-group], #FacetFiltersPillsForm [data-filter-group]'
    );
    const matchesActiveFilter = (element) => {
      const jsFilter = event
        ? event.target.closest('[data-filter-group]')
        : undefined;
      return jsFilter
        ? element.dataset.filterName === jsFilter.dataset.filterName
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesActiveFilter(element)
    );
    facetsToRender.forEach((element) => {
      const formId = element.closest('form')?.id;
      const currentForm = formId ? document.getElementById(formId) : null;
      const currentFilter = Array.from(
        currentForm?.querySelectorAll('[data-filter-group]') || []
      ).find(
        (filter) => filter.dataset.filterName === element.dataset.filterName
      );

      if (currentFilter) {
        currentFilter.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Keep the active group mounted so updating the other groups preserves focus.
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // this.controller.abort();
    FacetFiltersForm.renderPage(searchParams, event, true);
  }

  onSubmitHandler(event) {
    if (isConstructorCollectionActive()) {
      return;
    }

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form'
    );

    const parent = event.target.closest('[data-filter-option]');
    if (parent && [...parent.querySelectorAll('[data-filter-options]')].length) {
      const inputs = [
        ...parent
          .querySelector('[data-filter-options]')
          .querySelectorAll('input'),
      ];
      // console.log(inputs);
      inputs.map((input) => (input.checked = false));
    }

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form')
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      // const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        // if (!isMobile) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          forms.push(this.createSearchParams(form));
        }
        // } else if (form.id === 'FacetFiltersFormMobile') {
        //     forms.push(this.createSearchParams(form));
        // }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    if (isConstructorCollectionActive()) {
      return;
    }

    event.preventDefault();
    this.clearPendingSubmit();
    FacetFiltersForm.toggleActiveFacets();
    let item = event.target.closest('facet-remove');
    if (!item && event.target.nodeName === 'facet-remove') {
      item = event.target;
    }
    const url =
      item.dataset.href.indexOf('?') == -1
        ? ''
        : item.dataset.href.slice(item.dataset.href.indexOf('?') + 1);
    if (controller) {
      controller.abort();
    }

    if (Stats?.sendEventDataLayerViaShopify) {
      const event_category = 'filters--new';
      const eventLabelValue = textToCamelCase(item.innerText || '');

      if (url) {
        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: `filter_remove_${eventLabelValue}`,
        });
      } else {
        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: 'clear_filters',
        });
      }
    }

    FacetFiltersForm.renderPage(url, event, true);
  }

  onBestFilterClick(event) {
    if (isConstructorCollectionActive()) {
      return;
    }

    event.preventDefault();
    this.clearPendingSubmit();

    // FacetFiltersForm.toggleActiveFacets();
    let item = event.target.closest('facet-best');
    if (!item && event.target.nodeName === 'facet-best') {
      item = event.target;
    }
    item.classList.add('twc-btn--loading');
    const url =
      item.dataset.href.indexOf('?') == -1
        ? ''
        : item.dataset.href.slice(item.dataset.href.indexOf('?') + 1);
    if (controller) {
      controller.abort();
    }
    const isActive = item.dataset.filterActive !== 'true';
    item.dataset.filterActive = isActive ? 'true' : 'false';
    item.classList.toggle('bg-gld-ink', isActive);
    item.classList.toggle('text-gld-white', isActive);
    FacetFiltersForm.renderPage(url, event, true);
  }

  static srollToTopSection() {
    const offset = getHeaderSectionHeight() + 20;
    const breakpoint =
      document.querySelector('#collectionTopHeader') ||
      document.querySelector('[data-collection-products]');
    // console.log('breakpoint', breakpoint.getBoundingClientRect().top, offset);
    if (breakpoint) {
      const scrollBreakpoint =
        breakpoint.getBoundingClientRect().top - offset + window.scrollY;
      if (scrollBreakpoint) {
        window.scrollTo({ top: scrollBreakpoint, behavior: 'smooth' });
      }
    }
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('.gld-filter__price-submit');

    const onRangeInput = this.onRangeInput.bind(this);
    const onRangeChange = this.onRangeChange.bind(this);
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('input', onRangeInput);
      element.addEventListener('change', onRangeChange);
    });
    this.setMinAndMaxValues();
  }

  onRangeInput() {
    this.showSubmitButton();
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.target);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = input.value != '' ? Number(input.value) : false;
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value !== false && value < min) input.value = min;
    if (value !== false && value > max) input.value = max;
  }

  showSubmitButton() {
    this.submitButton?.style.removeProperty('display');
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    if (this.getAttribute('aria-disabled') === 'true') return;
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetBest extends HTMLElement {
  constructor() {
    super();
    const facetLink = this;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onBestFilterClick(event);
  }
}

customElements.define('facet-best', FacetBest);
